var map = {
	"../admin/cases/cases.module": [
		"./src/app/admin/cases/cases.module.ts",
		0
	],
	"../admin/clients/clients.module": [
		"./src/app/admin/clients/clients.module.ts",
		9
	],
	"../admin/communications/communications.module": [
		"./src/app/admin/communications/communications.module.ts",
		11
	],
	"../admin/customers/customers.module": [
		"./src/app/admin/customers/customers.module.ts",
		13
	],
	"../admin/finance/transactions/transactions.module": [
		"./src/app/admin/finance/transactions/transactions.module.ts",
		12
	],
	"../admin/promotion-codes/promotion-codes.module": [
		"./src/app/admin/promotion-codes/promotion-codes.module.ts",
		16
	],
	"../admin/roles/roles.module": [
		"./src/app/admin/roles/roles.module.ts",
		17
	],
	"../admin/users/users.module": [
		"./src/app/admin/users/users.module.ts",
		14
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		1
	],
	"./cases/cases.module": [
		"./src/app/clients/cases/cases.module.ts",
		4
	],
	"./clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		5
	],
	"./create/create.module": [
		"./src/app/clients/create/create.module.ts",
		3
	],
	"./customers/customers.module": [
		"./src/app/customers/customers.module.ts",
		2
	],
	"./dispute/dispute.module": [
		"./src/app/customers/dispute/dispute.module.ts",
		7
	],
	"./invoices/invoices.module": [
		"./src/app/clients/invoices/invoices.module.ts",
		18
	],
	"./login/login-routing.module": [
		"./src/app/customers/login/login-routing.module.ts",
		8
	],
	"./marketing/marketing.module": [
		"./src/app/marketing/marketing.module.ts",
		19
	],
	"./pay/pay.module": [
		"./src/app/customers/pay/pay.module.ts",
		6
	],
	"./plan/plan.module": [
		"./src/app/customers/plan/plan.module.ts",
		15
	],
	"./settings/settings.module": [
		"./src/app/clients/settings/settings.module.ts",
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = 21